import { forwardRef, useId } from "react";
import { Field, Select as GardenSelect } from "@zendeskgarden/react-forms";
import type { FormSelectProps } from "./Interfaces";

export const Select = forwardRef<HTMLSelectElement, FormSelectProps>(
  (
    {
      id,
      name,
      label,
      hint,
      placeholder = "Selecione...",
      options,
      value,
      onChange,
      message,
      validation,
      className,
      wrapperClassName,
      ...rest
    },
    ref
  ) => {
    const uid = useId();
    const selectId = id ?? `select-${uid}`;

    return (
      <Field className={wrapperClassName}>
        {label && <Field.Label htmlFor={selectId}>{label}</Field.Label>}
        {hint && <Field.Hint>{hint}</Field.Hint>}

        <GardenSelect
          id={selectId}
          name={name}
          ref={ref}
          className={className}
          value={value}
          onChange={(e) => onChange?.(e, e.target.value)}
          {...rest}
        >
          {placeholder !== null && <option value="">{placeholder}</option>}
          {options.map((opt) => (
            <option key={opt.value} value={opt.value} disabled={opt.disabled}>
              {opt.label}
            </option>
          ))}
        </GardenSelect>

        {message && <Field.Message validation={validation}>{message}</Field.Message>}
      </Field>
    );
  }
);

Select.displayName = "FormSelect";
export default Select;
